export const DATE_TIME_FORMAT = {
  MM_DD_YYYY_hma: "MM/DD/yyyy, h:mm a",
  d_MMM_yyyy: "d MMM yyyy",
  MM_DD_YYYY: "MM/DD/YYYY",
  DD_MM_YYYY: "DD/MM/YYYY",
  MMM_DD_YYYY: "MMM DD, YYYY",
  DD_MMM_YYYY: "DD MMM, YYYY",
  HHmmss: "HH:mm:ss",
  HHmm: "HH:mm",
  D: "D",
  DD: "DD",
  Do: "Do",
  ddd: "ddd",
  MMM_YYYY: "MMM YYYY",
  DD_MM: "DD/MM",
  DDMMYYYY_HHmmss: "DDMMYYYY_HHmmss",
  YYYYMMDD_HHmmss: "YYYY-MM-DD HH:mm:ss"
};

export type Timezone = {
  code: string;
  name: string;
};

// Mapping Go-based custom format → Day.js format
export const FORMAT_DATE_TO_DAYJS: Record<string, string> = {
  // Time
  "HH:MM": "HH:mm",
  "HH:MM:SS": "HH:mm:ss",
  "HH:MM AM/PM": "hh:mm A",
  "HH:MM:SS AM/PM": "hh:mm:ss A",

  // Date
  "YYYY-MM-DD": "YYYY-MM-DD",
  "DD-MM-YYYY": "DD-MM-YYYY",
  "MM-DD-YYYY": "MM-DD-YYYY",
  "DD Month YYYY": "DD MMMM YYYY",
  "YYYY/MM/DD": "YYYY/MM/DD",

  // Datetime
  "YYYY-MM-DD HH:MM:SS": "YYYY-MM-DD HH:mm:ss",
  "DD-MM-YYYY HH:MM": "DD-MM-YYYY HH:mm",
  "MM/DD/YYYY HH:MM AM/PM": "MM/DD/YYYY hh:mm A",
  "MM/DD/YYYY HH:MM:SS AM/PM": "MM/DD/YYYY hh:mm:ss A",
  "YYYY-MM-DDTHH:MM:SSZ": "YYYY-MM-DDTHH:mm:ss[Z]",
  "YYYY-MM-DDTHH:MM:SS+00:00": "YYYY-MM-DDTHH:mm:ssZ",
  "YYYY-MM-DDTHH:MM:SS%s": "YYYY-MM-DDTHH:mm:ssZ"
};

export const TIME_FORMAT_DAYJS = ["HH:mm", "HH:mm:ss", "hh:mm A", "hh:mm:ss A"];
